export const textIdentifier = {
  "platform-closed-title": {
    "eng": "Platform Closed",
    "uz": "Platforma yopildi",
    "ru": "Платформа закрыта",
    "az": "Platforma bağlıdır",
    "ky": "Платформа жабылды",
    "arabic": "المنصة مغلقة"
  },
  "end-of-service-will-close-teacher": {
    "eng": "Please note that this platform will officially close at 11:59PM ({replace_rgx_1}) on {replace_rgx_2}. We encourage teachers and admins to download any necessary reports before this date. Thank you for using Cerebry.",
    "uz": "Iltimos, e'tibor bering: ushbu platforma {replace_rgx_2} kuni soat 23:59 da ({replace_rgx_1}) rasman yopiladi. O'qituvchilar va administratorlarga ushbu sanadan oldin barcha zarur hisobotlarni yuklab olishni tavsiya etamiz. Cerebry'dan foydalanganingiz uchun rahmat.",
    "ru": "Обратите внимание: данная платформа будет официально закрыта в 23:59 ({replace_rgx_1}) {replace_rgx_2}. Мы рекомендуем учителям и администраторам загрузить все необходимые отчеты до этой даты. Спасибо, что пользовались Cerebry.",
    "az": "Zəhmət olmasa nəzərə alın ki, bu platforma {replace_rgx_2} saat 23:59-da ({replace_rgx_1}) rəsmi olaraq bağlanacaq. Müəllim və administratorlara bu tarixdən əvvəl bütün lazımi hesabatları endirməyi tövsiyə edirik. Cerebry-dən istifadə etdiyiniz üçün təşəkkür edirik.",
    "ky": "Көңүл буруңуз: бул платформа {replace_rgx_2} саат 23:59да ({replace_rgx_1}) расмий түрдө жабылат. Мугалимдерге жана администраторлорго бул күнгө чейин бардык керектүү отчетторду жүктөп алууну сунуштайбыз. Cerebry'ни колдонгонуңуз үчүн рахмат.",
    "arabic": "يرجى ملاحظة أن هذه المنصة ستُغلق رسميًا في الساعة 11:59 مساءً (بتوقيت {replace_rgx_1}) يوم {replace_rgx_2}. نوصي المعلمين والمسؤولين بتنزيل جميع التقارير الضرورية قبل هذا التاريخ. شكرًا لاستخدامكم Cerebry."
  },
  "end-of-service-has-closed-teacher": {
    "eng": "Please note that this platform has officially closed at 11:59PM ({replace_rgx_1}) on {replace_rgx_2}. Thank you for using Cerebry.",
    "uz": "Iltimos, e'tibor bering: ushbu platforma {replace_rgx_2} kuni soat 23:59 da ({replace_rgx_1}) rasman yopildi. Cerebry'dan foydalanganingiz uchun rahmat.",
    "ru": "Обратите внимание: данная платформа была официально закрыта в 23:59 ({replace_rgx_1}) {replace_rgx_2}. Спасибо, что пользовались Cerebry.",
    "az": "Zəhmət olmasa nəzərə alın ki, bu platforma {replace_rgx_2} saat 23:59-da ({replace_rgx_1}) rəsmi olaraq bağlanmışdır. Cerebry-dən istifadə etdiyiniz üçün təşəkkür edirik.",
    "ky": "Көңүл буруңуз: бул платформа {replace_rgx_2} саат 23:59да ({replace_rgx_1}) расмий түрдө жабылды. Cerebry'ни колдонгонуңуз үчүн рахмат.",
    "arabic": "يرجى ملاحظة أن هذه المنصة قد أُغلقت رسميًا في الساعة 11:59 مساءً (بتوقيت {replace_rgx_1}) يوم {replace_rgx_2}. شكرًا لاستخدامكم Cerebry."
  },
  "end-of-service-will-close-student": {
    "eng": "Please note that this platform will officially close at 11:59PM ({replace_rgx_1}) on {replace_rgx_2}. Thank you for using Cerebry.",
    "uz": "Iltimos, e'tibor bering: ushbu platforma {replace_rgx_2} kuni soat 23:59 da ({replace_rgx_1}) rasman yopiladi. Cerebry'dan foydalanganingiz uchun rahmat.",
    "ru": "Обратите внимание: данная платформа будет официально закрыта в 23:59 ({replace_rgx_1}) {replace_rgx_2}. Спасибо, что пользовались Cerebry.",
    "az": "Zəhmət olmasa nəzərə alın ki, bu platforma {replace_rgx_2} saat 23:59-da ({replace_rgx_1}) rəsmi olaraq bağlanacaq. Cerebry-dən istifadə etdiyiniz üçün təşəkkür edirik.",
    "ky": "Көңүл буруңуз: бул платформа {replace_rgx_2} саат 23:59да ({replace_rgx_1}) расмий түрдө жабылат. Cerebry'ни колдонгонуңуз үчүн рахмат.",
    "arabic": "يرجى ملاحظة أن هذه المنصة ستُغلق رسميًا في الساعة 11:59 مساءً (بتوقيت {replace_rgx_1}) يوم {replace_rgx_2}. شكرًا لاستخدامكم Cerebry."
  },
  "end-of-service-has-closed-student": {
    "eng": "Please note that this platform has officially closed at 11:59PM ({replace_rgx_1}) on {replace_rgx_2}. Thank you for using Cerebry.",
    "uz": "Iltimos, e'tibor bering: ushbu platforma {replace_rgx_2} kuni soat 23:59 da ({replace_rgx_1}) rasman yopildi. Cerebry'dan foydalanganingiz uchun rahmat.",
    "ru": "Обратите внимание: данная платформа была официально закрыта в 23:59 ({replace_rgx_1}) {replace_rgx_2}. Спасибо, что пользовались Cerebry.",
    "az": "Zəhmət olmasa nəzərə alın ki, bu platforma {replace_rgx_2} saat 23:59-da ({replace_rgx_1}) rəsmi olaraq bağlanmışdır. Cerebry-dən istifadə etdiyiniz üçün təşəkkür edirik.",
    "ky": "Көңүл буруңуз: бул платформа {replace_rgx_2} саат 23:59да ({replace_rgx_1}) расмий түрдө жабылды. Cerebry'ни колдонгонуңуз үчүн рахмат.",
    "arabic": "يرجى ملاحظة أن هذه المنصة قد أُغلقت رسميًا في الساعة 11:59 مساءً (بتوقيت {replace_rgx_1}) يوم {replace_rgx_2}. شكرًا لاستخدامكم Cerebry."
  },
  "analysis": {
    "arabic": "تحليل",
    "az": "Təhlil",
    "chinese": null,
    "eng": "Analysis",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "Анализ",
    "ru": "Анализ",
    "uz": "Tahlil",
    "viet": null
  },
  "dashboard---teacher": {
    "arabic": "لوحة التحكم - المعلم",
    "az": "Panel - Müəllim",
    "chinese": null,
    "eng": "Dashboard - Teacher",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "Тактылар - Мугалим",
    "ru": "Панель управления - Учитель",
    "uz": "Boshqaruv paneli - O‘qituvchi",
    "viet": null
  },
  "Overview": {
    "arabic": "ملخص",
    "az": "Ümumi baxış",
    "chinese": null,
    "eng": "Overview",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "Обзор",
    "ru": "Обзор",
    "uz": "Sharh",
    "viet": null
  },
  "Usage": {
    "arabic": "الاستخدام",
    "az": "İstifadə",
    "chinese": null,
    "eng": "Usage",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "Колдонуу",
    "ru": "Использование",
    "uz": "Qo‘llash",
    "viet": null
  },
  "Proficiency": {
    "arabic": "الكفاءة",
    "az": "Bacarıq",
    "chinese": null,
    "eng": "Proficiency",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "Квалификация",
    "ru": "Уровень знания студентов",
    "uz": "O‘zlashtirish darajasi",
    "viet": null
  },
  "Question Analysis": {
    "arabic": "تحليل السؤال",
    "az": "Sualın təhlili",
    "chinese": null,
    "eng": "Question Analysis",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "Суроолордун анализи",
    "ru": "Анализ вопросов",
    "uz": "Savol tahlili",
    "viet": null
  },
  "Question Analysis in Round 1": {
    "arabic": "تحليل السؤال في الجولة 1",
    "az": "1-ci turda sualın təhlili",
    "chinese": null,
    "eng": "Question Analysis in Round 1",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "1-чи турда суроолордун анализи",
    "ru": "Анализ вопросов в раунде 1",
    "uz": "1-turda savol tahlili",
    "viet": null
  },
  "Question Analysis in Round 2": {
    "arabic": "تحليل السؤال في الجولة 2",
    "az": "2-ci turda sualın təhlili",
    "chinese": null,
    "eng": "Question Analysis in Round 2",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "2-чи турда суроолордун анализи",
    "ru": "Анализ вопросов в раунде 2",
    "uz": "2-turda savol tahlili",
    "viet": null
  },
  "districts/district": {
    "arabic": "المناطق/المقاطعات",
    "az": "Regionlar/region",
    "chinese": null,
    "eng": "Districts/District",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "Райондор/Район",
    "ru": "Район/Районы",
    "uz": "Tumanlar / Tuman",
    "viet": null
  },
  "schools": {
    "arabic": "المدارس",
    "az": "Məktəblər",
    "chinese": null,
    "eng": "Schools",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "Мектептер",
    "ru": "Школы",
    "uz": "Maktablar",
    "viet": null
  },
  "teachers": {
    "arabic": "المعلمون",
    "az": "Müəllimlər",
    "chinese": null,
    "eng": "Teachers",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "Мугалимдер",
    "ru": "Учителя",
    "uz": "O‘qituvchilar",
    "viet": null
  },
  "All Districts": {
    "arabic": "جميع المناطق",
    "az": "Bütün regionlar",
    "chinese": null,
    "eng": "All Districts",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "Бардык райондор",
    "ru": "Все регионы",
    "uz": "Barcha hududlar",
    "viet": null
  },
  "students": {
    "arabic": "طلاب",
    "az": "Şagirdlər",
    "chinese": null,
    "eng": "Students",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "Окуучулар",
    "ru": "Ученики",
    "uz": "O‘quvchilar",
    "viet": null
  },
  "Nationwide Teachers Login to the Platform at Least Once": {
    "arabic": "يجب على المعلمين على مستوى الدولة الدخول إلى المنصة مرة واحدة على الأقل",
    "az": "Ölkə üzrə müəllimlər ən azı bir dəfə platformaya daxil olurlar.",
    "chinese": null,
    "eng": "Nationwide Teachers Login to the Platform at Least Once",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "Бүткүл өлкө боюнча мугалимдер платформага жок дегенде бир жолу кирген",
    "ru": "По всей стране учителя заходият на плотформу хотя бы раз",
    "uz": "Respublikadagi kamida bir marta platformaga kirgan o‘qituvchilar",
    "viet": null
  },
  "Total Hours Teachers Engage on the Platform": {
    "arabic": "إجمالي الساعات التي يقضيها المعلمون على المنصة",
    "az": "Müəllimlərin platformada işlədiyi ümumi saatlar",
    "chinese": null,
    "eng": "Total Hours Teachers Engage on the Platform",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "Мугалимдердин платформада өткөргөн жалпы сааттары",
    "ru": "Общее количество часов, проведенных учителями на платформе",
    "uz": "O‘qituvchilarning platformada sarflagan umumiy vaqti",
    "viet": null
  },
  "nationwide-student-login-to-the-platform-at-least-once": {
    "arabic": "تسجيل دخول الطالب على مستوى الدولة إلى المنصة مرة واحدة على الأقل",
    "az": "Ən azı bir dəfə platformaya giriş edən ölkədaxili şagirdlər",
    "chinese": null,
    "eng": "Nationwide Student Login to the Platform at Least Once",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "Бүткүл өлкө боюнча окуучулар платформаны жок дегенде бир жолу колдонгон",
    "ru": "По всей стране ученики заходили на платформу хотя бы раз",
    "uz": "Ölkə üzrə şagirdlər platformaya azı bir dəfə daxil olur",
    "viet": null
  },
  "Total Hours Students Engage on the Platform": {
    "arabic": "إجمالي الساعات التي يقضيها الطلاب على المنصة",
    "az": "Şagirdlərin platformada keçirdiyi toplam saat",
    "chinese": null,
    "eng": "Total Hours Students Engage on the Platform",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "Окуучулардын платформада өткөргөн жалпы сааттары",
    "ru": "Общее количество часов, проведенных учащимися на платформе",
    "uz": "O‘quvchilarning platformada sarflagan umumiy vaqti",
    "viet": null
  },
  "Nationwide Students with Proficiency Level 2": {
    "arabic": "الطلاب على مستوى الدولة الحاصلين على مستوى الكفاءة 2",
    "az": "Ölkədə yetərlik səviyyəsi 2 olan şagirdlər",
    "chinese": null,
    "eng": "Nationwide Students with Proficiency Level 2",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "Бүткүл өлкө боюнча 2-деңгээл жана андан жогору квалификацияга ээ окуучулар",
    "ru": "Количество учащихся по всей стране с уровнем знаний 2",
    "uz": "Respublikadagi o‘zlashtirish darajasi 2 bo‘lgan o‘quvchilar",
    "viet": null
  },
  "Nationwide Students with Proficiency Level 3 & Above": {
    "arabic": "الطلاب على مستوى الدولة الحاصلين على مستوى الكفاءة 3 وما فوق",
    "az": "Ölkədə yetərlik səviyyəsi 3 və daha yuxarı olan şagirdlər",
    "chinese": null,
    "eng": "Nationwide Students with Proficiency Level 3 and Above",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "Бүткүл өлкө боюнча 3-деңгээл жана андан жогору квалификацияга ээ окуучулар",
    "ru": "Количество учащихся по всей стране с уровнем знаний 3 и выше",
    "uz": "Respublikadagi o‘zlashtirish darajasi 3 va undan yuqori bo‘lgan o‘quvchilar",
    "viet": null
  },
  "classes": {
    "arabic": "الفصول الدراسية",
    "az": "Siniflər",
    "chinese": null,
    "eng": "Classes",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "Класстар",
    "ru": "Классы",
    "uz": "Sinflar",
    "viet": null
  },
  "teacher-login-to-the-platform-at-least-once": {
    "arabic": "تسجيل دخول المعلم إلى المنصة مرة واحدة على الأقل",
    "az": "Ən azı bir dəfə platformaya giriş edən müəllim",
    "chinese": null,
    "eng": "Teacher Login to the Platform at Least Once",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "Мугалимдер платформаны жок дегенде бир жолу колдонгон",
    "ru": "Учитель заходил на плотформу хоты бы раз",
    "uz": "Kamida bir marta platformaga kirgan o‘qituvchilar",
    "viet": null
  },
  "Average Usage Hours Per Teacher": {
    "arabic": "متوسط ساعات الاستخدام لكل معلم",
    "az": "Hər müəllim üçün ortalama istifadə saatı",
    "chinese": null,
    "eng": "Average Usage Hours Per Teacher",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "Мугалимдердин орточо колдонуусунун сааттары",
    "ru": "Среднее количество часов на учителя",
    "uz": "Bir o‘qituvchi tomonidan sarflangan o‘rtacha vaqt",
    "viet": null
  },
  "Students Login to the Platform at Least Once": {
    "arabic": "يجب على الطلاب الدخول إلى المنصة مرة واحدة على الأقل",
    "az": "Şagirdlər platformaya azı bir dəfə daxil olur",
    "chinese": null,
    "eng": "Students Login to the Platform at Least Once",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "Окуучулар платформага жок дегенде бир жолу кирди",
    "ru": "Учащийся заходил на плотформу хотя бы раз",
    "uz": "Kamida bir marta platformaga kirgan o‘quvchilar",
    "viet": null
  },
  "Average Usage Hours Per Student": {
    "arabic": "متوسط ساعات الاستخدام لكل طالب",
    "az": "Hər şagird üçün ortalama istifadə saatı",
    "chinese": null,
    "eng": "Average Usage Hours Per Student",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "Окуучулардын орточо колдонуусунун сааттары",
    "ru": "Среднее количество часов на ученика",
    "uz": "Bir o‘quvchi tomonidan sarflangan o‘rtacha vaqt",
    "viet": null
  },
  "Average-Usage-Hours-Per-Student": {
    "arabic": "متوسط ساعات الاستخدام لكل طالب",
    "az": "Hər şagird üçün ortalama istifadə saatı",
    "chinese": null,
    "eng": "Average Usage Hours Per Student",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "Окуучулардын орточо колдонуусунун сааттары",
    "ru": "Среднее количество часов на ученика",
    "uz": "Bir o‘quvchi tomonidan sarflangan o‘rtacha vaqt",
    "viet": null
  },
  "Students who have Completed at Least 20 Questions": {
    "arabic": "الطلاب الذين أكملوا 20 سؤالاً على الأقل",
    "az": "Ən az 20 sualı tamamlayan şagirdlər",
    "chinese": null,
    "eng": "Students who have Completed at Least 20 Questions",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "Кеминде 20 суроону бүтүргөн окуучулар",
    "ru": "Ученики, выполнившие не менее 20 вопросов",
    "uz": "Kamida 20 ta savolga javob bergan o‘quvchilar",
    "viet": null
  },
  "Students who have Completed at Least 20 Questions in Round 1": {
    "arabic": "الطلاب الذين أكملوا 20 سؤالاً على الأقل في الجولة 1",
    "az": "1-ci turda ən azı 20 sualı tamamlayan şagirdlər",
    "chinese": null,
    "eng": "Students who have Completed at Least 20 Questions in Round 1",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "1-чи турда кеминде 20 суроону бүтүргөн окуучулар",
    "ru": "Ученики, выполнившие не менее 20 вопросов в раунде 1",
    "uz": "1-turda kamida 20 ta savolga javob bergan o‘quvchilar",
    "viet": null
  },
  "Students who have Completed at Least 10 Questions in Round 2": {
    "arabic": "الطلاب الذين أكملوا 10 سؤالات على الأقل في الجولة 2",
    "az": "2-ci turda ən azı 10 sualı tamamlayan şagirdlər",
    "chinese": null,
    "eng": "Students who have Completed at Least 10 Questions in Round 2",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "2-чи турда кеминде 10 суроону бүтүргөн окуучулар",
    "ru": "Ученики, выполнившие не менее 10 вопросов в раунде 2",
    "uz": "2-turda kamida 10 ta savolga javob bergan o‘quvchilar",
    "viet": null
  },
  "average-number-of-completed-questions-per-student": {
    "arabic": "متوسط عدد الأسئلة المكتملة لكل طالب",
    "az": "Bir şagirdin tamamladığı sualların ortalama sayı",
    "chinese": null,
    "eng": "Average Number of Completed Questions Per Student",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "Окуучулардын орточо бүтүргөн суроолорунун саны",
    "ru": "Среднее количество пройденных вопросов на одного учащегося",
    "uz": "Bir o‘quvchi uchun javob berilgan savollarning o‘rtacha miqdori",
    "viet": null
  },
  "Students with Proficiency Level 2 and Above": {
    "arabic": "الطلاب الحاصلين على مستوى الكفاءة 2 وما فوق",
    "az": "2-ci və daha yüksək bacarıq səviyyəsinə malik şagirdlərin",
    "chinese": null,
    "eng": "Students with Proficiency Level 2 and Above",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "Деңгээли 2 жана андан жогору болгон окуучулар",
    "ru": "Ученики с уровнем знаний 2 и выше",
    "uz": "O‘zlashtirish darajasi 2 va undan yuqori bo‘lgan o‘quvchilar",
    "viet": null
  },
  "No. of Students Achieving Proficiency Level 2": {
    "arabic": "عدد الطلاب الحاصلين على مستوى الكفاءة 2",
    "az": "2-ci bacarıq səviyyəsini əldə edən şagirdlərin sayı",
    "chinese": null,
    "eng": "Number of Students Achieving Proficiency Level 2",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "2-деңгээлди эгалдаган окуучулардын саны",
    "ru": "Количество учащихся, достигших уровня владения языком 2",
    "uz": "2-darajani egallagan o‘quvchilar soni",
    "viet": null
  },
  "No. of Students Achieving Proficiency Level 3 & Above": {
    "arabic": "عدد الطلاب الحاصلين على مستوى الكفاءة 3 وما فوق",
    "az": "3-cü və daha yüksək bacarıq səviyyəsinə çatan şagirdlərin sayı",
    "chinese": null,
    "eng": "Number of Students Achieving Proficiency Level 3 & Above",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "3-деңгээл жана андан жогору квалификацияга жеткен окуучулардын саны",
    "ru": "Количество учащихся, достигших уровня владения языком 3 и выше",
    "uz": "3 va undan yuqori bo‘lgan o‘zlashtirish darajasini egallayotgan o‘quvchilar soni",
    "viet": null
  },
  "number-of-improving-students": {
    "arabic": "عدد الطلاب المتحسنين",
    "az": "Təkmilləşən şagirdlərin sayı",
    "chinese": null,
    "eng": "Number of Improving Students",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "Өз жетишкендигин жакшырткан окуучулардын саны",
    "ru": "Количество учащихся, улучшающих свои знания",
    "uz": "Natijalari yaxshilanayotgan o‘quvchilar soni",
    "viet": null
  },
  "Proficiency By Student": {
    "arabic": "الكفاءة حسب الطالب",
    "az": "Şagirdə əsasən yetərlik",
    "chinese": null,
    "eng": "Proficiency By Student",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "Окуучунун квалификациясы боюнча",
    "ru": "Уровень знания учащихся",
    "uz": "O‘quvchining o‘zlashtirish darajasi",
    "viet": null
  },
  "Proficiency By Student in Round 1": {
    "arabic": "الكفاءة حسب الطالب في الجولة 1",
    "az": "1-ci turda şagirdə əsasən yetərlik",
    "chinese": null,
    "eng": "Proficiency By Student in Round 1",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "1-чи турда окуучунун квалификациясы боюнча",
    "ru": "Уровень знания учащихся в раунде 1",
    "uz": "1-turda o‘quvchining o‘zlashtirish darajasi",
    "viet": null
  },
  "Proficiency By Student in Round 2": {
    "arabic": "الكفاءة حسب الطالب في الجولة 2",
    "az": "2-ci turda şagirdə əsasən yetərlik",
    "chinese": null,
    "eng": "Proficiency By Student in Round 2",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "2-чи турда окуучунун квалификациясы боюнча",
    "ru": "Уровень знания учащихся в раунде 2",
    "uz": "2-turda o‘quvchining o‘zlashtirish darajasi",
    "viet": null
  },
  "below-level-2": {
    "arabic": "أقل من المستوى 2",
    "az": "2-ci səviyyədən aşağı",
    "chinese": null,
    "eng": "Below Level 2",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "2-деңгээлден төмөн",
    "ru": "Ниже уровня 2",
    "uz": "2-darajadan past",
    "viet": null
  },
  "level-2-&-above": {
    "arabic": "المستوى 2 وما فوق",
    "az": "2-ci səviyyədən yuxarı",
    "chinese": null,
    "eng": "Level 2 & Above",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "2-деңгээл жана андан жогору",
    "ru": "Уровень 2 и выше",
    "uz": "2-daraja va undan yuqori",
    "viet": null
  },
  "Student Name": {
    "arabic": "اسم الطالب",
    "az": "Şagirdin adı",
    "chinese": null,
    "eng": "Student Name",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "Окуучунун аты",
    "ru": "Имя ученика",
    "uz": "O‘quvchining ismi",
    "viet": null
  },
  "student-improvements-by-percentage-score-per-exercise": {
    "arabic": "تحسنات الطلاب حسب النسبة المئوية للدرجات لكل تمرين",
    "az": "Şagirdin hər çalışma üzrə faiz göstəricisi ilə irəliləyişləri",
    "chinese": null,
    "eng": "Student Improvements By Percentage Score Per Exercise",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "Ар бир көнүгүү боюнча окуучунун пайыздык упайын жакшыртуусу",
    "ru": "Улучшения учеников в процентах за упражнение",
    "uz": "O‘quvchi natijasining yaxshilanishi (har bir topshiriq bo‘yicha)",
    "viet": null
  },
  "Question Completion By Student": {
    "arabic": "إكمال السؤال من قبل الطالب",
    "az": "Şagird tərəfindən sual tamamlanması",
    "chinese": null,
    "eng": "Question Completion By Student",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "Суроолорду бүткөрүлүшү боюнча окуучу",
    "ru": "Выполнение вопросов студентами",
    "uz": "O‘quvchi bajargan savollar soni",
    "viet": null
  },
  "Question Completion By Student in Round 1": {
    "arabic": "إكمال السؤال من قبل الطالب في الجولة 1",
    "az": "1-ci turda şagird tərəfindən sual tamamlanması",
    "chinese": null,
    "eng": "Question Completion By Student in Round 1",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "1-чи турда окуучу тарапынан суроолорду бүткөрүлүшү",
    "ru": "Выполнение вопросов студентами в раунде 1",
    "uz": "1-turda o‘quvchi tomonidan bajargan savollar soni",
    "viet": null
  },
  "Question Completion By Student in Round 2": {
    "arabic": "إكمال السؤال من قبل الطالب في الجولة 2",
    "az": "2-ci turda şagird tərəfindən sual tamamlanması",
    "chinese": null,
    "eng": "Question Completion By Student in Round 2",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "2-чи турда окуучу тарапынан суроолорду бүткөрүлүшү",
    "ru": "Выполнение вопросов студентами в раунде 2",
    "uz": "2-turda o‘quvchi tomonidan bajargan savollar soni",
    "viet": null
  },
  "Usage Hours By Teacher": {
    "arabic": "ساعات الاستخدام حسب المعلم",
    "az": "Müəllimin istifadə saatları",
    "chinese": null,
    "eng": "Usage Hours By Teacher",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "Мугалимдердин колдонуу сааттары",
    "ru": "Время использования учителем",
    "uz": "O‘qituvchi sarflagan vaqt (soatlarda)",
    "viet": null
  },
  "Usage Hours By Student": {
    "arabic": "ساعات الاستخدام حسب الطالب",
    "az": "Şagird tərəfindən istifadə saatları",
    "chinese": null,
    "eng": "Usage Hours By Student",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "Окуучулардын колдонуу сааттары",
    "ru": "Время использования учеником",
    "uz": "O‘quvchi sarflagan vaqt (soatlarda)",
    "viet": null
  },
  "Teacher Name": {
    "arabic": "اسم المعلم",
    "az": "Müəllim adı",
    "chinese": null,
    "eng": "Teacher Name",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "Мугалимдин аты",
    "ru": "Имя учетиля",
    "uz": "O‘qituvchining ismi",
    "viet": null
  },
  "incorrect-attempts-by-question-processes-": {
    "arabic": "محاولات خاطئة من خلال عمليات السؤال ",
    "az": "Sual ilə bağlı edilən yanlış cəhdlər",
    "chinese": null,
    "eng": "Incorrect Attempts by Question Processes ",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "Суроо процессиндеги ката аракеттери",
    "ru": "Неправильные попытки по вопросам",
    "uz": "Har bir savol bo‘yicha muvaffaqiyatsiz urinishlar",
    "viet": null
  },
  "interpret/evaluate": {
    "arabic": "تفسير/تقييم",
    "az": "Şərh et/qiymətləndir",
    "chinese": null,
    "eng": "Interpret/Evaluate",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "Түшүндүрүү/Баалоо",
    "ru": "Интерпретировать/оценить",
    "uz": "Talqin qilish/baholash",
    "viet": null
  },
  "formulate": {
    "arabic": "صياغة",
    "az": "İfadə et",
    "chinese": null,
    "eng": "Formulate",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "Калыптандыруу",
    "ru": "Сформулировавть",
    "uz": "Ifodalash",
    "viet": null
  },
  "reason": {
    "arabic": "سبب",
    "az": "Səbəb",
    "chinese": null,
    "eng": "Reason",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "Жооп табуу",
    "ru": "Рассуждение",
    "uz": "Mulohaza yuritish",
    "viet": null
  },
  "employ": {
    "arabic": "توظيف",
    "az": "Tətbiq et",
    "chinese": null,
    "eng": "Employ",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "Колдонуу",
    "ru": "Применить",
    "uz": "Qo‘llash",
    "viet": null
  },
  "Question No.": {
    "arabic": "رقم السؤال",
    "az": "Sual nömrəsi",
    "chinese": null,
    "eng": "Question Number",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "Суроонун номери",
    "ru": "Номер вопроса",
    "uz": "Savol raqami",
    "viet": null
  },
  "Content": {
    "arabic": "محتوى",
    "az": "Məzmun",
    "chinese": null,
    "eng": "Content",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "Мазмун",
    "ru": "Содержание",
    "uz": "Kontent",
    "viet": null
  },
  "Processes": {
    "arabic": "العمليات",
    "az": "Proseslər",
    "chinese": null,
    "eng": "Processes",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "Процесстер",
    "ru": "Процессы",
    "uz": "Jarayonlar",
    "viet": null
  },
  "Problem Solving Strategies": {
    "arabic": "استراتيجيات حل المشكلات",
    "az": "Problemləri həll etmə üsulları",
    "chinese": null,
    "eng": "Problem Solving Strategies",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "Маселелерди чечүү стратегиялары",
    "ru": "Стратегии решения проблем",
    "uz": "Muammolarga yechim topish usullari",
    "viet": null
  },
  "Proficiency Level": {
    "arabic": "مستوى الكفاءة",
    "az": "Yetərlilik səviyyəsi",
    "chinese": null,
    "eng": "Proficiency Level",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "Квалификация деңгээли",
    "ru": "Уровень знаний",
    "uz": "O‘zlashtirish darajasi",
    "viet": null
  },
  "Brief Description": {
    "arabic": "وصف موجز",
    "az": "Qısa təsvir",
    "chinese": null,
    "eng": "Brief Description",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "Кыскача сүрөттөө",
    "ru": "Краткое содержание",
    "uz": "Qisqacha tavsif",
    "viet": null
  },
  "Number of Students": {
    "arabic": "عدد الطلاب",
    "az": "Şagirdlərin sayı",
    "chinese": null,
    "eng": "Number of Students",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "Окуучулардын саны",
    "ru": "Количество учеников",
    "uz": "O‘quvchilar soni",
    "viet": null
  },
  "Correct with 1 Hint": {
    "arabic": "تصحيح مع 1 تلميحات",
    "az": "1 ipucu ilə doğru cavab",
    "chinese": null,
    "eng": "Correct with 1 Hints",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "1 кеңеш менен туура",
    "ru": "Правильно с 1 подсказками",
    "uz": "1 marotaba yordam olingan holda to‘g‘ri",
    "viet": null
  },
  "Correct with 2 Hints": {
    "arabic": "تصحيح مع 2 تلميحات",
    "az": "2 ipucu ilə doğru cavab",
    "chinese": null,
    "eng": "Correct with 2 Hints",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "2 кеңеш менен туура",
    "ru": "Правильно с 2 подсказками",
    "uz": "2 marotaba yordam olingan holda to‘g‘ri",
    "viet": null
  },
  "Incorrect": {
    "arabic": "غير صحيح",
    "az": "Səhv",
    "chinese": null,
    "eng": "Incorrect",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "Туура эмес",
    "ru": "Неправильно",
    "uz": "Noto‘g‘ri",
    "viet": null
  },
  "Not Attempted": {
    "arabic": "لم تتم المحاولة",
    "az": "Cəhd edilməyən",
    "chinese": null,
    "eng": "Not Attempted",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "Аткарылган жок",
    "ru": "Не выполнено",
    "uz": "Urinib ko‘rilmadi",
    "viet": null
  },
  "dashboard---principal": {
    "arabic": "لوحة التحكم - المدير",
    "az": "Panel - Direktor",
    "chinese": null,
    "eng": "Dashboard - Principal",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "Тактылар - Директор",
    "ru": "Панель управления - Директор школы",
    "uz": "Boshqaruv paneli - Maktab direktori",
    "viet": null
  },
  "Correct with no Hints": {
    "arabic": "صحيح بدون تلميحات",
    "az": "Heç bir ipucu olmadan doğru cavab",
    "chinese": null,
    "eng": "Correct with no Hints",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "Кеңешсиз туура",
    "ru": "Правильно, без подсказок",
    "uz": "Hech qanday maslahatlarsiz to'g'rilang",
    "viet": null
  },
  "regions": {
    "arabic": "المناطق",
    "az": "Regionlar",
    "chinese": null,
    "eng": "Regions",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "Региондор",
    "ru": "Регионы",
    "uz": "Hududlar",
    "viet": null
  },
  "regions/region": {
    "arabic": "المناطق/المنطقة",
    "az": "Regionlar/region",
    "chinese": null,
    "eng": "Regions/Region",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "Региондор/Регион",
    "ru": "Регионы/Регион",
    "uz": "Mintaqalar/Mintaqalar",
    "viet": null
  },
  "all-regions": {
    "arabic": "جميع المناطق",
    "az": "Bütün regionlar",
    "chinese": null,
    "eng": "All Regions",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "Бардык аймактар",
    "ru": "Все районы",
    "uz": "Barcha tumanlar",
    "viet": null
  },
  "Teachers Login to the Platform at Least Once": {
    "arabic": "يجب على المعلمين الدخول إلى المنصة مرة واحدة على الأقل",
    "az": "Ən azı bir dəfə platformaya giriş edən müəllimlər ",
    "chinese": null,
    "eng": "Teachers Login to the Platform at Least Once",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "Мугалимдер платформага жок дегенде бир жолу кирди",
    "ru": "Учителя заходят на платформу хотя бы раз",
    "uz": "Kamida bir marta platformaga kirgan o‘qituvchilar",
    "viet": null
  },
  "Top 10 Schools Nationwide": {
    "arabic": "أفضل 10 مدارس على مستوى البلاد",
    "az": "Ölkə üzrə ən yaxşı 10 məktəb",
    "chinese": null,
    "eng": "Top 10 Schools Nationwide",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "Бүткүл өлкө боюнча алдыңкы 10 мектеп",
    "ru": "Топ-10 школ по всей стране",
    "uz": "Respublikadagi Top 10 maktablar",
    "viet": null
  },
  "Total No. of Questions Attempted": {
    "arabic": "إجمالي عدد الأسئلة التي تمت محاولتها",
    "az": "Müraciət olunan sualların ümumi sayı",
    "chinese": null,
    "eng": "Total Number of Questions Attempted",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "Аткарылган суроолордун жалпы саны",
    "ru": "Общее количество пройденных вопросов",
    "uz": "Bajarishga urinib ko‘rilgan savollarning umumiy soni",
    "viet": null
  },
  "Total No. of Questions Attempted in Round 1": {
    "arabic": "إجمالي عدد الأسئلة التي تمت محاولتها في الجولة 1",
    "az": "1-ci turda müraciət olunan sualların ümumi sayı",
    "chinese": null,
    "eng": "Total Number of Questions Attempted in Round 1",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "1-чи турда аткарылган суроолордун жалпы саны",
    "ru": "Общее количество пройденных вопросов в раунде 1",
    "uz": "1-turda bajarishga urinib ko‘rilgan savollarning umumiy soni",
    "viet": null
  },
  "Total No. of Questions Attempted in Round 2": {
    "arabic": "إجمالي عدد الأسئلة التي تمت محاولتها في الجولة 2",
    "az": "2-ci turda müraciət olunan sualların ümumi sayı",
    "chinese": null,
    "eng": "Total Number of Questions Attempted in Round 2",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "2-чи турда аткарылган суроолордун жалпы саны",
    "ru": "Общее количество пройденных вопросов в раунде 2",
    "uz": "2-turda bajarishga urinib ko‘rilgan savollarning umumiy soni",
    "viet": null
  },
  "Nationwide Students with Improved Scores After Re-Attempts": {
    "arabic": "طلاب على مستوى الدولة يحصلون على درجات أفضل بعد إعادة المحاولات",
    "az": "Ölkədə təkrar cəhdlərdən sonra xalları təkmilləşən şagirdlər",
    "chinese": null,
    "eng": "Nationwide Students with Improved Scores After Re-Attempts",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "Кайталап жооп берүүдө баллы жакшырган окуучулар (бүткүл өлкө боюнча)",
    "ru": "Количество учащихся по всей стране с улучшенными результатами после повторных попыток",
    "uz": "Respublikadagi qayta urinishlardan so‘ng natijalari yaxshilangan o‘quvchilar soni",
    "viet": null
  },
  "Nationwide Students with Improved Scores After Re-Attempts in Round 1": {
    "arabic": "طلاب على مستوى الدولة يحصلون على درجات أفضل بعد إعادة المحاولة في الجولة 1",
    "az": "1-ci turda təkrar cəhdlərdən sonra xalları təkmilləşən şagirdlər",
    "chinese": null,
    "eng": "Nationwide Students with Improved Scores After Re-Attempts in Round 1",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "1-чи турда кайталап жооп берүүдө баллы жакшырган окуучулардын пайызы",
    "ru": "Процент учащихся с улучшенными результатами после повторных попыток в раунде 1",
    "uz": "1-turda qayta urinishlardan so‘ng natijalari yaxshilangan o‘quvchilarning ulushi",
    "viet": null
  },
  "Nationwide Students with Improved Scores After Re-Attempts in Round 2": {
    "arabic": "طلاب على مستوى الدولة يحصلون على درجات أفضل بعد إعادة المحاولة في الجولة 2",
    "az": "2-ci turda təkrar cəhdlərdən sonra xalları təkmilləşən şagirdlər",
    "chinese": null,
    "eng": "Nationwide Students with Improved Scores After Re-Attempts in Round 2",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "2-чи турда кайталап жооп берүүдө баллы жакшырган окуучулардын пайызы",
    "ru": "Процент учащихся с улучшенными результатами после повторных попыток в раунде 2",
    "uz": "2-turda qayta urinishlardan so‘ng natijalari yaxshilangan o‘quvchilarning ulushi",
    "viet": null
  },
  "Percentage of Students with Improved Scores After Re-Attempts": {
    "arabic": "نسبة الطلاب الذين حصلوا على درجات أفضل بعد إعادة المحاولة",
    "az": "Təkrar cəhdlərdən sonra xalları təkmilləşən şagirdlərin faizi",
    "chinese": null,
    "eng": "Percentage of Students with Improved Scores After Re-Attempts",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "Кайталап жооп берүүдө баллы жакшырган окуучулардын пайызы",
    "ru": "Процент учащихся с улучшенными результатами после повторных попыток",
    "uz": "Qayta urinishlardan so‘ng natijalari yaxshilangan o‘quvchilarning ulushi",
    "viet": null
  },
  "Percentage of Students with Improved Scores After Re-Attempts in Round 1": {
    "arabic": "نسبة الطلاب الذين حصلوا على درجات أفضل بعد إعادة المحاولة في الجولة 1",
    "az": "1-ci turda təkrar cəhdlərdən sonra xalları təkmilləşən şagirdlərin faizi",
    "chinese": null,
    "eng": "Percentage of Students with Improved Scores After Re-Attempts in Round 1",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "1-чи турда кайталап жооп берүүдө баллы жакшырган окуучулардын пайызы",
    "ru": "Процент учащихся с улучшенными результатами после повторных попыток в раунде 1",
    "uz": "1-turda qayta urinishlardan so‘ng natijalari yaxshilangan o‘quvchilarning ulushi",
    "viet": null
  },
  "Percentage of Students with Improved Scores After Re-Attempts in Round 2": {
    "arabic": "نسبة الطلاب الذين حصلوا على درجات أفضل بعد إعادة المحاولة في الجولة 2",
    "az": "2-ci turda təkrar cəhdlərdən sonra xalları təkmilləşən şagirdlərin faizi",
    "chinese": null,
    "eng": "Percentage of Students with Improved Scores After Re-Attempts in Round 2",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "2-чи турда кайталап жооп берүүдө баллы жакшырган окуучулардын пайызы",
    "ru": "Процент учащихся с улучшенными результатами после повторных попыток в раунде 2",
    "uz": "2-turda qayta urinishlardan so‘ng natijalari yaxshilangan o‘quvchilarning ulushi",
    "viet": null
  },
  "Percentage of Teachers Who Have Logged In At Least Once": {
    "arabic": "نسبة المعلمين الذين قاموا بتسجيل الدخول مرة واحدة على الأقل",
    "az": "Ən azı bir dəfə giriş etmiş müəllimlərin faizi",
    "chinese": null,
    "eng": "Percentage of Teachers Who Have Logged In At Least Once",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "Жок дегенде бир жолу кирген мугалимдердин пайызы",
    "ru": "Процент учителей, вошедших в систему хотя бы один раз",
    "uz": "Kamida bir marta platformaga kirgan o‘qituvchilar ulushi",
    "viet": null
  },
  "percentage": {
    "arabic": "نسبة مئوية",
    "az": "Faiz",
    "chinese": null,
    "eng": "Percentage",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "Пайыз",
    "ru": "Процент",
    "uz": "Ulush",
    "viet": null
  },
  "Teachers Total Engagement Hours": {
    "arabic": "إجمالي ساعات مشاركة المعلمين",
    "az": "Müəllimlərin ümumi iş saatları",
    "chinese": null,
    "eng": "Teachers Total Engagement Hours",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "Мугалимдердин жалпы активдүүлүк сааттары",
    "ru": "Общее количество часов работы учителей",
    "uz": "O‘qituvchilar sarflagan umumiy vaqt",
    "viet": null
  },
  "School Name": {
    "arabic": "اسم المدرسة",
    "az": "Məktəb Adı",
    "chinese": null,
    "eng": "School Name",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "Мектеп аты",
    "ru": "Название школы",
    "uz": "Maktab nomi",
    "viet": null
  },
  "Students Total Engagement Hours": {
    "arabic": "إجمالي ساعات مشاركة الطلاب",
    "az": "Şagirdlərin platformada keçirdiyi toplam saat",
    "chinese": null,
    "eng": "Students Total Engagement Hours",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "Окуучулардын жалпы активдүүлүк сааттары",
    "ru": "Общее количество часов работы учеников",
    "uz": "O‘quvchilar sarflagan umumiy vaqt",
    "viet": null
  },
  "Enter at least 3 characters": {
    "arabic": "أدخل 3 أحرف على الأقل",
    "az": "Ən azı 3 simvol daxil edin",
    "chinese": null,
    "eng": "Enter at least 3 characters",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "Жок дегенде 3 тамга киргизиңиз",
    "ru": "Введите не менее 3 символов",
    "uz": "Eng kamida 3 ta belgi kiriting",
    "viet": null
  },
  "Search": {
    "arabic": "يبحث",
    "az": "Axtar",
    "chinese": null,
    "eng": "Search",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "Издөө",
    "ru": "Поиск",
    "uz": "Qidirish",
    "viet": null
  },
  "Percentage of Students Who Have Logged In At Least Once": {
    "arabic": "نسبة الطلاب الذين قاموا بتسجيل الدخول مرة واحدة على الأقل",
    "az": "Azı bir dəfə daxil olmuş şagirdlərin faizi",
    "chinese": null,
    "eng": "Percentage of Students Who Have Logged In At Least Once",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "Жок дегенде бир жолу кирген окуучулардын пайызы",
    "ru": "Процент учащихся, которые хотя бы раз входили в систему",
    "uz": "Kamida bir marta platformaga kirgan o‘quvchilar ulushi",
    "viet": null
  },
  "grade-7/grade-8/grade-9/grade-10": {
    "arabic": "الصف السابع/الصف الثامن/الصف التاسع/الصف العاشر",
    "az": "7-ci sinif/8-ci sinif/9-cu sinif/10-cu sinif",
    "chinese": null,
    "eng": "Grade 7/Grade 8/Grade 9/Grade 10",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "7-класс / 8-класс / 9-класс / 10-класс",
    "ru": "7 класс/ 8 класс/ 9 класс/ 10 класс",
    "uz": "7-sinf / 8-sinf / 9-sinf / 10-sinf",
    "viet": null
  },
  "overall": {
    "arabic": "إجمالي",
    "az": "Ümumi",
    "chinese": null,
    "eng": "Overall",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "Жалпы",
    "ru": "Общий показатель",
    "uz": "Umumiy ko‘rsatkich",
    "viet": null
  },
  "Percentage of Students with Proficiency Level 2": {
    "arabic": "نسبة الطلاب الذين حصلوا على مستوى الكفاءة 2",
    "az": "Yetərlilik səviyyəsi 2 olan şagirdlərin faizi",
    "chinese": null,
    "eng": "Percentage of Students with Proficiency Level 2",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "Деңгээли 2 болгон окуучулардын пайызы",
    "ru": "Процент учащихся, достигших уровня владения языком 2",
    "uz": "O‘zlashtirish darajasi 2 bo‘lgan o‘quvchilar soni",
    "viet": null
  },
  "Percentage of Students with Proficiency Level 3 & Above": {
    "arabic": "نسبة الطلاب الذين حصلوا على مستوى الكفاءة 3 وما فوق",
    "az": "Yetərlilik səviyyəsi 3 və daha yuxarı olan şagirdlərin faizi",
    "chinese": null,
    "eng": "Percentage of Students with Proficiency Level 3 & Above",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "Деңгээли 3 жана андан жогору болгон окуучулардын пайызы",
    "ru": "Процент учащихся, достигших уровня владения языком 3 и выше",
    "uz": "O‘zlashtirish darajasi 3 va undan yuqori bo‘lgan o‘quvchilar soni",
    "viet": null
  },
  "No. of Students with Proficiency Level 2 & Above": {
    "arabic": "عدد الطلاب الحاصلين على مستوى الكفاءة 2 وما فوق",
    "az": "Yetərlilik səviyyəsi 2 və daha yuxarı olan şagirdlərin sayı",
    "chinese": null,
    "eng": "Number of Students with Proficiency Level 2 & Above",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "Деңгээли 2 жана андан жогору болгон окуучулардын саны",
    "ru": "Количество учащихся, достигших уровня владения языком 2 и выше",
    "uz": "O‘zlashtirish darajasi 2 va undan yuqori bo‘lgan o‘quvchilar soni",
    "viet": null
  },
  "No. of Students with Proficiency Level 3 & Above": {
    "arabic": "عدد الطلاب الذين حصلوا على مستوى الكفاءة 3 وما فوق",
    "az": "Yetərlilik səviyyəsi 3 və daha yuxarı olan şagirdlərin sayı",
    "chinese": null,
    "eng": "Number of Students with Proficiency Level 3 & Above",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "Деңгээли 3 жана андан жогору болгон окуучулардын саны",
    "ru": "Количество учащихся, достигших уровня владения языком 3 и выше",
    "uz": "O‘zlashtirish darajasi 3 va undan yuqori bo‘lgan o‘quvchilar soni",
    "viet": null
  },
  "No. of Students with Proficiency Level 2": {
    "arabic": "عدد الطلاب الذين حصلوا على مستوى الكفاءة 2",
    "az": "Yetərlilik səviyyəsi 2 olan şagirdlərin sayı",
    "chinese": null,
    "eng": "Number of Students with Proficiency Level 2",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "Деңгээли 2 болгон окуучулардын саны",
    "ru": "Количество учащихся, достигших уровня владения языком 2",
    "uz": "O‘zlashtirish darajasi 2 bo‘lgan o‘quvchilar soni",
    "viet": null
  },
  "overall-%": {
    "arabic": "إجمالي ٪",
    "az": "Ümumi %",
    "chinese": null,
    "eng": "Overall %",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "Жалпы %",
    "ru": "Общий показатель %",
    "uz": "Umumiy ko‘rsatkich (% da)",
    "viet": null
  },
  "percentage-of-students-with-improved-scores-after-re-attempt": {
    "arabic": "نسبة الطلاب الذين حصلوا على درجات أفضل بعد إعادة المحاولة",
    "az": "Təkrar cəhddən sonra xalları təkmilləşən şagirdlərin faizi",
    "chinese": null,
    "eng": "Percentage of Students with Improved Scores After Re-Attempt",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "Кайталап жооп берүүдө баллы жакшырган окуучулардын пайызы",
    "ru": "Процент учащихся с улучшенными результатами после повторных попыток",
    "uz": "Qayta urinishdan so‘ng natijalari yaxshilangan o‘quvchilarning ulushi",
    "viet": null
  },
  "No. of Students with Improved Scores After Re-Attempt": {
    "arabic": "عدد الطلاب الذين حصلوا على درجات أفضل بعد إعادة المحاولة",
    "az": "Təkrar cəhddən sonra xalları təkmilləşən şagirdlərin sayı",
    "chinese": null,
    "eng": "Number of Students with Improved Scores After Re-Attempt",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "Кайталап жооп берүүдө баллы жакшырган окуучулардын саны",
    "ru": "Количество учащихся с улучшенными результатами после повторной попытки",
    "uz": "Qayta urinishdan so‘ng natijalari yaxshilangan o‘quvchilarning soni",
    "viet": null
  },
  "No. of Students with Improved Scores After Re-Attempt in Round 1": {
    "arabic": "عدد الطلاب الذين حصلوا على درجات أفضل بعد إعادة المحاولة في الجولة 1",
    "az": "1-ci turda təkrar cəhddən sonra xalları təkmilləşən şagirdlərin sayı",
    "chinese": null,
    "eng": "Number of Students with Improved Scores After Re-Attempt in Round 1",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "1-чи турда аткарылган суроолордун саны",
    "ru": "Количество учащихся с улучшенными результатами после повторной попытки в раунде 1",
    "uz": "1-chorakda bajarilgan savollar soni",
    "viet": null
  },
  "No. of Students with Improved Scores After Re-Attempt in Round 2": {
    "arabic": "عدد الطلاب الذين حصلوا على درجات أفضل بعد إعادة المحاولة في الجولة 2",
    "az": "2-ci turda təkrar cəhddən sonra xalları təkmilləşən şagirdlərin sayı",
    "chinese": null,
    "eng": "Number of Students with Improved Scores After Re-Attempt in Round 2",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "2-чи турда аткарылган суроолордун саны",
    "ru": "Количество учащихся с улучшенными результатами после повторной попытки в раунде 2",
    "uz": "2-chorakda bajarilgan savollar soni",
    "viet": null
  },
  "No. of Questions Attempted": {
    "arabic": "عدد الأسئلة التي تمت محاولتها",
    "az": "Müraciət edilən sualların sayı",
    "chinese": null,
    "eng": "Number of Questions Attempted",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "Аткарылган суроолордун саны",
    "ru": "Количество пройденных вопросов",
    "uz": "Bajarishga urinib ko‘rilgan savollar soni",
    "viet": null
  },
  "No. of Questions Attempted in Round 1": {
    "arabic": "عدد الأسئلة التي تمت محاولتها في الجولة 1",
    "az": "1-ci turda müraciət edilən sualların sayı",
    "chinese": null,
    "eng": "Number of Questions Attempted in Round 1",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "1-чи турда аткарылган суроолордун саны",
    "ru": "Количество пройденных вопросов в раунде 1",
    "uz": "1-chorakda bajarilgan savollar soni",
    "viet": null
  },
  "No. of Questions Attempted in Round 2": {
    "arabic": "عدد الأسئلة التي تمت محاولتها في الجولة 2",
    "az": "2-ci turda müraciət edilən sualların sayı",
    "chinese": null,
    "eng": "Number of Questions Attempted in Round 2",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "2-чи турда аткарылган суроолордун саны",
    "ru": "Количество пройденных вопросов в раунде 2",
    "uz": "2-chorakda bajarilgan savollar soni",
    "viet": null
  },
  "dashboard---ministry": {
    "arabic": "لوحة التحكم - الوزارة",
    "az": "Panel - Nazirlik",
    "chinese": null,
    "eng": "Dashboard - Ministry",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "Көзөмөл тактасы - Билим берүү министрлиги",
    "ru": "Панель управления - Министерство",
    "uz": "Boshqaruv paneli - Vazirlik",
    "viet": null
  },
  "dashboard---student": {
    "arabic": "لوحة التحكم - الطالب",
    "az": "Panel - Şagird",
    "chinese": null,
    "eng": "Dashboard - Student",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "Башкы бет - Окуучу",
    "ru": "Панель управления - Ученик",
    "uz": "Boshqaruv paneli - O‘quvchi",
    "viet": null
  },
  "mathematics": {
    "arabic": "الرياضيات",
    "az": "Riyaziyyat",
    "chinese": null,
    "eng": "Mathematics",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "Математика",
    "ru": "Математика",
    "uz": "Matematika",
    "viet": null
  },
  "science": {
    "arabic": "علوم",
    "az": "Təbiət elmləri",
    "chinese": null,
    "eng": "Science",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "Илим",
    "ru": "Наука",
    "uz": "Tabiiy fanlar",
    "viet": null
  },
  "Science Competency":{
    "arabic": "الكفاءات العلمية",
    "az": "Təbiət elmləri üzrə səriştələr",
    "chinese": null,
    "eng": "Science Competency",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "Илимий компетенттүүлүк",
    "ru": "Научная компетентность",
    "uz": "Tabiiy fanlar kompetensiyasi",
    "viet": null
  },
  "Hours-Online": {
    "arabic": "ساعات العمل على الإنترنت",
    "az": "Onlayn saatlar",
    "chinese": null,
    "eng": "Hours Online",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "Онлайн Сааттар",
    "ru": "Часы онлайн",
    "uz": "Onlayn holatdagi vaqt (soatlar)",
    "viet": null
  },
  "Questions-Completed": {
    "arabic": "الأسئلة المكتملة",
    "az": "Tamamlanmış suallar",
    "chinese": null,
    "eng": "Questions completed",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "Жооп берилген суроолор",
    "ru": "Выполненные вопросы",
    "uz": "Bajarilgan savollar",
    "viet": null
  },
  "Questions-Completed-in-Round-1": {
    "arabic": "الأسئلة المكتملة في الجولة 1",
    "az": "1-ci turda tamamlanmış suallar",
    "chinese": null,
    "eng": "Questions Completed in Round 1",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "1-чи турда аяктаган суроолор",
    "ru": "Выполненные вопросы в раунде 1",
    "uz": "1-turda bajarilgan savollar",
    "viet": null
  },
  "Questions-Completed-in-Round-2": {
    "arabic": "الأسئلة المكتملة في الجولة 2",
    "az": "2-ci turda tamamlanmış suallar",
    "chinese": null,
    "eng": "Questions Completed in Round 2",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "2-чи турда аяктаган суроолор",
    "ru": "Выполненные вопросы в раунде 2",
    "uz": "2-turda bajarilgan savollar",
    "viet": null
  },
  "Improvements After Subsequent Tries in Round 1": {
    "arabic": "تحسينات بعد المحاولات اللاحقة في الجولة 1",
    "az": "Ardıcıl cəhdlərdən sonra əldə olunan irəliləyiş 1-ci dövr",
    "chinese": null,
    "eng": "Improvements After Subsequent Tries in Round 1",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "Кайталоолордон кийинки жакшыруулар 1-чи дöвр",
    "ru": "Улучшения после последующих попыток в 1-м раунде",
    "uz": "Davomli urinishlardan keyingi natija yaxshilanishi 1-tur",
    "viet": null
  },
  "Improvements After Subsequent Tries in Round 2": {
    "arabic": "تحسينات بعد المحاولات اللاحقة في الجولة 2",
    "az": "Ardıcıl cəhdlərdən sonra əldə olunan irəliləyiş 2-ci dövr",
    "chinese": null,
    "eng": "Improvements After Subsequent Tries in Round 2",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "Кайталоолордон кийинки жакшыруулар 2-чи дöвр",
    "ru": "Улучшения после последующих попыток во 2-м раунде",
    "uz": "Davomli urinishlardan keyingi natija yaxshilanishi 2-tur",
    "viet": null
  },
  "all": {
    "arabic": "الجميع",
    "az": "Hamısı",
    "chinese": null,
    "eng": "All",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "Баары",
    "ru": "Все",
    "uz": "Barcha",
    "viet": null
  },
  "All Classes": {
    "arabic": "جميع الفصول",
    "az": "Bütün siniflər",
    "chinese": null,
    "eng": "All Classes",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "Бардык класстар",
    "ru": "Все классы",
    "uz": "Barcha sinflar",
    "viet": null
  },
  "Average No. of Completed Questions Per Student": {
    "arabic": "متوسط عدد الأسئلة المكتملة لكل طالب",
    "az": "Bir şagird üçün tamamlanmış sualların ortalama sayı",
    "chinese": null,
    "eng": "Average No. of Completed Questions Per Student",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "Ар бир окуучу боюнча аяктаган суроолордун орточо саны",
    "ru": "Среднее количество выполненных вопросов на одного ученика",
    "uz": "Har bir o‘quvchi uchun bajarilgan savollarning o‘rtacha miqdori",
    "viet": null
  },
  "Average No. of Completed Questions Per Student in Round 1": {
    "arabic": "متوسط عدد الأسئلة المكتملة لكل طالب في الجولة 1",
    "az": "1-ci dövrədə bir şagird üçün tamamlanmış sualların ortalama sayı",
    "chinese": null,
    "eng": "Average No. of Completed Questions Per Student in Round 1",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "1-чи турда бир окуучу боюнча аяктаган суроолордун орточо саны",
    "ru": "Среднее количество выполненных вопросов на одного ученика в 1-м раунде",
    "uz": "1-turda har bir o‘quvchi uchun bajarilgan savollarning o‘rtacha miqdori",
    "viet": null
  },
  "Average No. of Completed Questions Per Student in Round 2": {
    "arabic": "متوسط عدد الأسئلة المكتملة لكل طالب في الجولة 2",
    "az": "2-ci dövrədə bir şagird üçün tamamlanmış sualların ortalama sayı",
    "chinese": null,
    "eng": "Average No. of Completed Questions Per Student in Round 2",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "2-чи турда бир окуучу боюнча аяктаган суроолордун орточо саны",
    "ru": "Среднее количество выполненных вопросов на одного ученика во 2-м раунде",
    "uz": "2-turda har bir o‘quvchi uchun bajarilgan savollarning o‘rtacha miqdori",
    "viet": null
  },
  "Week": {
    "arabic": "أسبوع",
    "az": "Həftə",
    "chinese": null,
    "eng": "Week",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "Жума",
    "ru": "Неделя",
    "uz": "Hafta",
    "viet": null
  },
  "View Data": {
    "arabic": "عرض البيانات",
    "az": "Məlumata bax",
    "chinese": null,
    "eng": "View Data",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "Маалыматтарды көрүү",
    "ru": "Просмотреть данные",
    "uz": "Ma’lumotlarni ko‘rish",
    "viet": null
  },
  "download": {
    "arabic": "تحميل",
    "az": "Yüklə",
    "chinese": null,
    "eng": "Download",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "Жүктөө",
    "ru": "Скачать",
    "uz": "Yuklab olish",
    "viet": null
  },
  "download-all-data":{
    "arabic": "تحميل جميع البيانات",
    "az": "Bütün məlumatları yüklə",
    "chinese": null,
    "eng": "Download All Data",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "Бардык маалыматтарды жүктөө",
    "ru": "Скачать все данные",
    "uz": "Barcha ma’lumotlarni yuklab olish",
    "viet": null
  },
  "please-wait": {
    "arabic": "يرجى الانتظار",
    "az": "Zəhmət olmasa gözləyin",
    "chinese": null,
    "eng": "Please wait",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "Күтө туруңуз",
    "ru": "Пожалуйста, подождите",
    "uz": "Iltimos, kuting",
    "viet": null
  },
  "Daily": {
    "arabic": "يوميًا",
    "az": "Gündəlik",
    "chinese": null,
    "eng": "Daily",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "Күн сайын",
    "ru": "Ежедневно",
    "uz": "Kunlik",
    "viet": null
  },
  "no-progress-data-available-at-this-time.-please-come-back-after-sometime": {
    "arabic": "لا تتوفر بيانات تقدم في الوقت الحالي. يُرجى العودة بعد فترة.",
    "az": "Hazırda əldə olunan irəliləyiş ilə bağlı məlumatlar yoxdur. Zəhmət olmasa bir az sonra yenidən baxın.",
    "chinese": null,
    "eng": "No progress data available at this time. Please come back after sometime",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "Учурда прогресс тууралуу маалымат жок. Кийинчерээк келиңиз.",
    "ru": "На данный момент сведения об успеваемости отсутствуют. Пожалуйста, вернитесь через некоторое время.",
    "uz": "Ayni damda natijalarning yaxshilanishi bo‘yicha ma’lumot mavjud emas. Iltimos, bir muddat o‘tgandan so‘ng, qayta urinib ko‘ring. ",
    "viet": null
  },
  "Student Improvements By Questions": {
    "arabic": "تحسينات الطلاب من خلال الأسئلة",
    "az": "Suallar üzrə şagird təkmilləşmələri",
    "chinese": null,
    "eng": "Student Improvements By Questions",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "Суроолор боюнча окуучулардын жакшыртуулары",
    "ru": "Улучшения учеников по вопросам",
    "uz": "O‘quvchi natijasining yaxshilanishi (savollar bo‘yicha)",
    "viet": null
  },
  "Student Improvements By Questions in Round 1": {
    "arabic": "تحسينات الطلاب من خلال الأسئلة في الجولة 1",
    "az": "1-ci dövr üzrə suallarla təkmilləşmələr",
    "chinese": null,
    "eng": "Student Improvements By Questions in Round 1",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "1-чи дöврдө суроолор боюнча окуучулардын жакшыртуулары",
    "ru": "Улучшения учеников по вопросам в 1-м раунде",
    "uz": "O‘quvchi natijasining yaxshilanishi (1-turda)",
    "viet": null
  },
  "Student Improvements By Questions in Round 2": {
    "arabic": "تحسينات الطلاب من خلال الأسئلة في الجولة 2",
    "az": "2-ci dövr üzrə suallarla təkmilləşmələr",
    "chinese": null,
    "eng": "Student Improvements By Questions in Round 2",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "2-чи дöврдө суроолор боюнча окуучулардын жакшыртуулары",
    "ru": "Улучшения учеников по вопросам во 2-м раунде",
    "uz": "O‘quvchi natijasining yaxshilanishi (2-turda)",
    "viet": null   
  },
  "exercise-1": {
    "arabic": "تمرين 1",
    "az": "Çalışma №1",
    "chinese": null,
    "eng": "Exercise 1",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "Көнүгүү 1",
    "ru": "Упражнение 1",
    "uz": "1-topshiriq",
    "viet": null
  },
  "2nd Try": {
    "arabic": "المحاولة الثانية",
    "az": "2-ci cəhd",
    "chinese": null,
    "eng": "2nd Try",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "2-аракет",
    "ru": "2-ая попытка",
    "uz": "2-urinish",
    "viet": null
  },
  "3rd Try": {
    "arabic": "المحاولة الثالثة",
    "az": "3-cü cəhd",
    "chinese": null,
    "eng": "3rd Try",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "3-аракет",
    "ru": "3-ая попытка",
    "uz": "3-urinish",
    "viet": null
  },
  "exercise": {
    "arabic": "يمارس",
    "az": "Çalışma",
    "chinese": null,
    "eng": "Exercise",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "Көнүгүү",
    "ru": "Упражнение ",
    "uz": "Topshiriq",
    "viet": null
  },
  "q1": {
    "arabic": "س1",
    "az": "Sual №1",
    "chinese": null,
    "eng": "Q1",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "Суроолор -1",
    "ru": "Вопрос 1",
    "uz": "1-savol",
    "viet": null
  },
  "answer---incorrect": {
    "arabic": "الإجابة - غير صحيحة",
    "az": "Cavab - Yanlışdır",
    "chinese": null,
    "eng": "Answer - Incorrect",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "Жооп - Туура эмес",
    "ru": "Ответ неверный",
    "uz": "Javob - Noto‘g‘ri",
    "viet": null
  },
  "answer---correct": {
    "arabic": "الإجابة - صحيحة",
    "az": "Cavab - Doğru",
    "chinese": null,
    "eng": "Answer - Correct",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "Жооп - Туура ",
    "ru": "Ответ верный",
    "uz": "Javob - To‘g‘ri",
    "viet": null
  },
  "class": {
    "arabic": "فصل",
    "az": "Sinif",
    "chinese": null,
    "eng": "Class",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "Класс",
    "ru": "Класс",
    "uz": "Sinf",
    "viet": null
  },
  "Weekly": {
    "arabic": "أسبوعي",
    "az": "Həftəlik",
    "chinese": null,
    "eng": "Weekly",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "Жума сайын",
    "ru": "Еженедельно",
    "uz": "Haftalik",
    "viet": null
  },
  "Untitled": {
    "arabic": "بدون عنوان",
    "az": "Adı yoxdur",
    "chinese": null,
    "eng": "Untitled",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "Untitled",
    "ru": "Без Названия",
    "uz": "Nomi yo'q",
    "viet": null
  },
  "No. of Improving Students": {
    "arabic": "عدد الطلاب المتحسنين",
    "az": "Yaxşılaşan Tələbələrin Sayı",
    "chinese": null,
    "eng": "No. of Improving Students",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "Окуучулардын саны",
    "ru": "Количество Улучшающихся Студентов",
    "uz": "Yaxshilanishayotgan O‘quvchilar Soni",
    "viet": null
  },
  "No. of Improving Students in Round 1": {
    "arabic": "عدد الطلاب المتحسنين في الجولة 1",
    "az": "1-ci dövrədə yaxşılaşan tələbələrin sayı",
    "chinese": null,
    "eng": "No. of Improving Students in Round 1",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "1-чи турдагы окуучулардын саны",
    "ru": "Количество Улучшающихся Студентов в 1-м раунде",
    "uz": "1-turda yaxshilanishayotgan o‘quvchilar soni",
    "viet": null
  },
  "No. of Improving Students in Round 2": {
    "arabic": "عدد الطلاب المتحسنين في الجولة 2",
    "az": "2-ci dövrədə yaxşılaşan tələbələrin sayı",
    "chinese": null,
    "eng": "No. of Improving Students in Round 2",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "2-чи турдагы окуучулардын саны",
    "ru": "Количество Улучшающихся Студентов во 2-м раунде",
    "uz": "2-turda yaxshilanishayotgan o‘quvchilar soni",
    "viet": null
  },
  "Dashboard": {
    "arabic": "لوحة القيادة",
    "az": "İdarə Paneli",
    "chinese": null,
    "eng": "Dashboard",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "Куралдар тактасы",
    "ru": "Панель Управления",
    "uz": "Boshqaruv Paneli",
    "viet": null
  },
  "Student Improvements By Percentage Score Per": {
    "arabic": "تحسينات الطلاب حسب النسبة المئوية للدرجات لكل {replace_rgx_1}",
    "az": "Şagirdin hər {replace_rgx_1} üzrə faiz göstəricisi ilə irəliləyişləri",
    "chinese": null,
    "eng": "Student Improvements By Percentage Score Per {replace_rgx_1}",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "Ар бир {replace_rgx_1} үчүн пайыздык упай боюнча студенттердин жакшыруусу",
    "ru": "Улучшение Студентов По Проценту Баллов {replace_rgx_1}",
    "uz": "O‘quvchi Yaxshilanishi Foiz Bo'yicha Har {replace_rgx_1}",
    "viet": null
  },
  "Student Improvements By Percentage Score Per {regex} in Round 1": {
    "arabic": "تحسينات الطلاب حسب النسبة المئوية للدرجات لكل {replace_rgx_1} في الجولة 1",
    "az": "Şagirdin hər {replace_rgx_1} üzrə faiz göstəricisi ilə irəliləyişləri",
    "chinese": null,
    "eng": "Student Improvements By Percentage Score Per {replace_rgx_1} in Round 1",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "Ар бир {replace_rgx_1} үчүн пайыздык упай боюнча студенттердин жакшыруусу",
    "ru": "Улучшение Студентов По Проценту Баллов {replace_rgx_1} в 1-м раунде",
    "uz": "1-turda O‘quvchi Yaxshilanishi Foiz Bo'yicha Har {replace_rgx_1}",
    "viet": null
  },
  "Student Improvements By Percentage Score Per {regex} in Round 2": {
    "arabic": "تحسينات الطلاب حسب النسبة المئوية للدرجات لكل {replace_rgx_1} في الجولة 2",
    "az": "Şagirdin hər {replace_rgx_1} üzrə faiz göstəricisi ilə irəliləyişləri",
    "chinese": null,
    "eng": "Student Improvements By Percentage Score Per {replace_rgx_1} in Round 2",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "Ар бир {replace_rgx_1} үчүн пайыздык упай боюнча студенттердин жакшыруусу",
    "ru": "Улучшение Студентов По Проценту Баллов {replace_rgx_1} во 2-м раунде",
    "uz": "2-turda O‘quvchi Yaxshilanishi Foiz Bo'yicha Har {replace_rgx_1}",
    "viet": null
  },
  "student": {
    "arabic": "طالب",
    "az": "Tələbə",
    "chinese": null,
    "eng": "Student",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "Студент",
    "ru": "Студент",
    "uz": "O‘quvchi",
    "viet": null
  },
  "teacher": {
    "arabic": "مدرس",
    "az": "Müəllim",
    "chinese": null,
    "eng": "Teacher",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "Мугалим",
    "ru": "Учитель",
    "uz": "O'qituvchi",
    "viet": null
  },
  "principal": {
    "arabic": "رئيسي",
    "az": "Direktor",
    "chinese": null,
    "eng": "Principal",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "Директор",
    "ru": "Директор",
    "uz": "Direktor",
    "viet": null
  },
  "ministry": {
    "arabic": "وزارة",
    "az": "Nazirlik",
    "chinese": null,
    "eng": "Ministry",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "министрлиги",
    "ru": "Министерство",
    "uz": "Vazirlik",
    "viet": null
  },
  "districts": {
    "arabic": "المناطق",
    "az": "Rayonlar",
    "chinese": null,
    "eng": "Districts",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "Райондор",
    "ru": "Регионы",
    "uz": "Hududlar",
    "viet": null
  },
  "Choose Subject": {
    "arabic": "اختر الموضوع",
    "az": "Mövzu Seçin",
    "chinese": null,
    "eng": "Choose Subject",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "Теманы тандаңыз",
    "ru": "Выберите Тему",
    "uz": "Mavzu Tanlang",
    "viet": null
  },
  "Nationwide Students Login to the Platform at Least Once": {
    "arabic": "يجب على الطلاب على مستوى الدولة الدخول إلى المنصة مرة واحدة على الأقل",
    "az": "Ölkə üzrə şagirdlər platformaya azı bir dəfə daxil olur",
    "chinese": null,
    "eng": "Nationwide Students Login to the Platform at Least Once",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "Жалпы улуттук студенттер платформага жок дегенде бир жолу киришет",
    "ru": "Всенациональное Вхождение Студентов На Платформу По Крайней Мере Один Раз",
    "uz": "Butun O'zbekiston O‘quvchilar Platformaga Kamida Bir Marta Kirishi",
    "viet": null
  },
  "nationwide-students-with-proficiency-level-2-&-above": {
    "arabic": "الطلاب على مستوى الدولة الحاصلين على مستوى الكفاءة 2 وما فوق",
    "az": "Bütün Ölkə üzrə Səriştəlilik Səviyyəsi 2 və Daha Yüksək olan Tələbələr",
    "chinese": null,
    "eng": "Nationwide Students with Proficiency Level 2 & Above",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "2-деңгээл жана андан жогору болгон улуттук студенттер",
    "ru": "Всенациональные Студенты С Уровнем Владения 2 И Выше",
    "uz": "Butun O'zbekiston O‘quvchilar 2-Yoki Undan Yuqori Malaka Darajasiga Ega",
    "viet": null
  },
  "Total No. of Students with PISA Proficiency Level 2 & Above": {
    "arabic": "العدد الإجمالي للطلاب الحاصلين على مستوى الكفاءة 2 وما فوق في اختبار PISA",
    "az": "PISA yetərlik səviyyəsi 2 və daha yuxarı olan şagirdlərin toplam sayı",
    "chinese": null,
    "eng": "Total No. of Students with PISA Proficiency Level 2 & Above",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "PISA 2-деңгээли жана андан жогору болгон студенттердин жалпы саны",
    "ru": "Общее Количество Студентов С Уровнем Владения PISA 2 И Выше",
    "uz": "2-Yoki Undan Yuqori PISA Malaka Darajasiga Ega O‘quvchilar Soni",
    "viet": null
  },
  "Total No. of Students with Proficiency Level 2 & Above": {
    "arabic": "إجمالي عدد الطلاب الحاصلين على مستوى الكفاءة 2 وما فوق",
    "az": "Səriştəlilik Səviyyəsi 2 və Daha Yüksək olan Tələbələrin Ümumi Sayı",
    "chinese": null,
    "eng": "Total No. of Students with Proficiency Level 2 & Above",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "2-деңгээлден жогору болгон студенттердин жалпы саны",
    "ru": "Общее Количество Студентов С Уровнем Владения 2 И Выше",
    "uz": "2-Yoki Undan Yuqori Malaka Darajasiga Ega O‘quvchilar Soni",
    "viet": null
  },
  "Total No. of Students with Proficiency Level 2": {
    "arabic": "إجمالي عدد الطلاب الحاصلين على مستوى الكفاءة 2",
    "az": "Səriştəlilik Səviyyəsi 2 olan Tələbələrin Ümumi Sayı",
    "chinese": null,
    "eng": "Total No. of Students with Proficiency Level 2",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "2-деңгээлден болгон студенттердин жалпы саны",
    "ru": "Общее Количество Студентов С Уровнем Владения 2",
    "uz": "2-Yoki Undan Malaka Darajasiga Ega O‘quvchilar Soni",
    "viet": null
  },
  "Total No. of Students with Proficiency Level 3 & Above": {
    "arabic": "إجمالي عدد الطلاب الحاصلين على مستوى الكفاءة 3 وما فوق",
    "az": "Səriştəlilik Səviyyəsi 3 və Daha Yüksək olan Tələbələrin Ümumi Sayı",
    "chinese": null,
    "eng": "Total No. of Students with Proficiency Level 3 & Above",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "3-деңгээлден жогору болгон студенттердин жалпы саны",
    "ru": "Общее Количество Студентов С Уровнем Владения 3 И Выше",
    "uz": "3-Yoki Undan Yuqori Malaka Darajasiga Ega O‘quvchilar Soni",
    "viet": null
  },
  "Students with Proficiency Level 2 & Above": {
    "arabic": "الطلاب الحاصلين على مستوى الكفاءة 2 وما فوق",
    "az": "Yetərlik səviyyəsi 2 və daha yuxarı olan şagirdlər",
    "chinese": null,
    "eng": "Students with Proficiency Level 2 & Above",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "2-деңгээлден жогору болгон студенттер",
    "ru": "Студенты С Уровнем Владения 2 И Выше",
    "uz": "2-Yoki Undan Yuqori Malaka Darajasiga Ega O‘quvchilar",
    "viet": null
  },
  "Students with Proficiency Level 2": {
    "arabic": "الطلاب الحاصلين على مستوى الكفاءة 2",
    "az": "Yetərlik səviyyəsi 2 olan şagirdlər",
    "chinese": null,
    "eng": "Students with Proficiency Level 2",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "2-деңгээлден болгон студенттер",
    "ru": "Студенты С Уровнем Владения 2",
    "uz": "2-Yoki Undan Malaka Darajasiga Ega O‘quvchilar",
    "viet": null
  },
  "Students with Proficiency Level 3 & Above": {
    "arabic": "الطلاب الحاصلين على مستوى الكفاءة 3 وما فوق",
    "az": "Yetərlik səviyyəsi 3 və daha yuxarı olan şagirdlər",
    "chinese": null,
    "eng": "Students with Proficiency Level 3 & Above",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "3-деңгээлден жогору болгон студенттер",
    "ru": "Студенты С Уровнем Владения 3 И Выше",
    "uz": "3-Yoki Undan Yuqori Malaka Darajasiga Ega O‘quvchilar",
    "viet": null
  },
  "no.-of-students-achieving-proficiency-level-2-&-above": {
    "arabic": "عدد الطلاب الحاصلين على مستوى الكفاءة 2 وما فوق",
    "az": "2 və daha yuxarı yetərlik səviyyəsinə çatan şagirdlərin sayı",
    "chinese": null,
    "eng": "No. of Students Achieving Proficiency Level 2 & Above",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "2 жана андан жогору деңгээлге жеткен студенттердин саны",
    "ru": "Количество Студентов Достигших Уровня Владения 2 И Выше",
    "uz": "2-Yoki Undan Yuqori Malaka Darajasiga Erishgan O‘quvchilar Soni",
    "viet": null
  },
  "Students who have Improved After Subsequent Attempts": {
    "arabic": "الطلاب الذين تحسنوا بعد المحاولات اللاحقة",
    "az": "Sonrakı Cəhdlərdən Sonra İrəliləyən Tələbələr",
    "chinese": null,
    "eng": "Students who have Improved After Subsequent Attempts",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "Кийинки аракеттерден кийин жакшырган студенттер",
    "ru": "Студенты, Улучшившие После Последующих Попыток",
    "uz": "Keyingi Urinishlardan Keyin Yaxshilangan O‘quvchilar",
    "viet": null
  },
  "Students who have Improved After Subsequent Attempts in Round 1": {
    "arabic": "الطلاب الذين تحسنوا بعد المحاولات اللاحقة في الجولة 1",
    "az": "1-ci dövrədə sonrakı cəhdlərdən sonra irəliləyən tələbələr",
    "chinese": null,
    "eng": "Students who have Improved After Subsequent Attempts in Round 1",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "1-чи турда кийинки аракеттерден кийин жакшырган студенттер",
    "ru": "Студенты, Улучшившие После Последующих Попыток в 1-м раунде",
    "uz": "1-turda keyingi urinishlardan keyin yaxshilangan o‘quvchilar",
    "viet": null
  },
  "Students who have Improved After Subsequent Attempts in Round 2": {
    "arabic": "الطلاب الذين تحسنوا بعد المحاولات اللاحقة في الجولة 2",
    "az": "2-ci dövrədə sonrakı cəhdlərdən sonra irəliləyən tələbələr",
    "chinese": null,
    "eng": "Students who have Improved After Subsequent Attempts in Round 2",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "2-чи турда кийинки аракеттерден кийин жакшырган студенттер",
    "ru": "Студенты, Улучшившие После Последующих Попыток во 2-м раунде",
    "uz": "2-turda keyingi urinishlardan keyin yaxshilangan o‘quvchilar",
    "viet": null
  },
  "Incorrect Attempts by Question Processes": {
    "arabic": "محاولات خاطئة من خلال عمليات السؤال",
    "az": "Suallar Üzrə Səhv Cəhdlər",
    "chinese": null,
    "eng": "Incorrect Attempts by Question Processes",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "Суроо процесстери боюнча туура эмес аракеттер",
    "ru": "Неправильные Попытки По Процессам Вопросов",
    "uz": "Savollar Bo'yicha Noto'g'ri Urinishlar",
    "viet": null
  },
  "Incorrect Attempts by Question Processes in Round 1": {
    "arabic": "محاولات خاطئة من خلال عمليات السؤال في الجولة 1",
    "az": "1-ci dövrədə suallar üzrə səhv cəhdlər",
    "chinese": null,
    "eng": "Incorrect Attempts by Question Processes in Round 1",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "1-чи турда суроо процесстери боюнча туура эмес аракеттер",
    "ru": "Неправильные Попытки По Процессам Вопросов В 1-м Раунде",
    "uz": "1-turda savollar bo'yicha noto'g'ri urinishlar",
    "viet": null
  },
  "Incorrect Attempts by Question Processes in Round 2": {
    "arabic": "محاولات خاطئة من خلال عمليات السؤال في الجولة 2",
    "az": "2-ci dövrədə suallar üzrə səhv cəhdlər",
    "chinese": null,
    "eng": "Incorrect Attempts by Question Processes in Round 2",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "2-чи турда суроо процесстери боюнча туура эмес аракеттер",
    "ru": "Неправильные Попытки По Процессам Вопросов Во 2-м Раунде",
    "uz": "2-turda savollar bo'yicha noto'g'ri urinishlar",
    "viet": null
  },
  "no-practice-data-is-available-at-the-moment-please-check-back-later": {
    "arabic": "لا تتوفر بيانات الممارسة في الوقت الحالي. يرجى التحقق مرة أخرى لاحقًا.",
    "az": "Hazırda heç bir təcrübə məlumatları mövcud deyil. Zəhmət olmasa sonra yenidən yoxlayın.",
    "chinese": null,
    "eng": "No practise data is available at the moment. Please check back later.",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "Учурда эч кандай практикалык маалымат жок. Сураныч, кийинчерээк кайра текшериңиз.",
    "ru": "Данных о практике на данный момент нет. Пожалуйста, зайдите позже.",
    "uz": "Hozirda amaliyotga oid ma'lumotlar mavjud emas. Iltimos, keyinroq tekshiring.",
    "viet": null
  },
  "search-by-school-name": {
    "arabic": "البحث حسب اسم المدرسة",
    "az": "Məktəb adı ilə axtarın",
    "chinese": null,
    "eng": "Search by school name",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "Мектептин аты боюнча издөө",
    "ru": "Поиск по названию школы",
    "uz": "Maktab nomi bo'yicha qidirish",
    "viet": null
  },
  "search-by-region-name": {
    "arabic": "البحث حسب اسم المنطقة",
    "az": "Bölgə adına görə axtarış",
    "chinese": null,
    "eng": "Search by region name",
    "hindi": null,
    "ja": "地域名で検索",
    "jp": null,
    "ky": "Аймактын аталышы боюнча издөө",
    "ru": "Поиск по названию региона",
    "uz": "Hudud nomi bo'yicha qidiring",
    "viet": "Tìm kiếm theo tên vùng"
  },
  "region-name": {
    "arabic": "اسم المنطقة",
    "az": "Bölgə adı",
    "chinese": null,
    "eng": "Region Name",
    "hindi": null,
    "ja": "地域名",
    "jp": null,
    "ky": "Райондун аталышы",
    "ru": "Название региона",
    "uz": "Hudud nomi",
    "viet": "Tên vùng"
  },
  "back": {
    "arabic": "خلف",
    "az": "Geri",
    "chinese": null,
    "eng": "Back",
    "hindi": null,
    "ja": "戻る",
    "jp": null,
    "ky": "Артка",
    "ru": "Назад",
    "uz": "Orqaga",
    "viet": "Trở lại"
  },
  "data": {
    "arabic": "بيانات",
    "az": "Məlumat",
    "chinese": null,
    "eng": "Data",
    "hindi": null,
    "ja": "データ",
    "jp": null,
    "ky": "Маалыматтар",
    "ru": "Данные",
    "uz": "Ma'lumotlar",
    "viet": "Dữ liệu"
  },
  "okay": {
    "arabic": "تمام",
    "az": "Yaxşı",
    "chinese": null,
    "eng": "Okay",
    "hindi": null,
    "ja": "OK",
    "jp": null,
    "ky": "макул",
    "ru": "Окей",
    "uz": "Xo'p",
    "viet": "Đồng ý"
  },
  "sure": {
    "arabic": "بالتأكيد",
    "az": "Əlbəttə",
    "chinese": null,
    "eng": "Sure",
    "hindi": null,
    "ja": "もちろん",
    "jp": null,
    "ky": "Албетте",
    "ru": "Конечно",
    "uz": "Albatta",
    "viet": "Chắc chắn"
  },
  "the-data-is-being-downloaded-now-and-will-be-sent-to-your-email-soon": {
    "arabic": "يتم تنزيل البيانات الآن وسيتم إرسالها إلى بريدك الإلكتروني قريبًا.",
    "az": "Məlumatlar indi yüklənir və tezliklə emailinizə göndəriləcək.",
    "chinese": null,
    "eng": "The data is being downloaded now and will be sent to your email soon.",
    "hindi": null,
    "ja": "データが現在ダウンロードされており、すぐにメールに送信されます。",
    "jp": null,
    "ky": "Дайындар азыр жүктөлүп алынууда жана жакында электрондук почтаңызга жөнөтүлөт.",
    "ru": "Данные загружаются и скоро будут отправлены на вашу электронную почту.",
    "uz": "Ma'lumotlar hozir yuklanmoqda va tez orada elektron pochtangizga yuboriladi.",
    "viet": "Dữ liệu đang được tải xuống và sẽ sớm được gửi đến email của bạn."
  },
  "moe-dashboard": {
    "arabic": "لوحة معلومات وزارة التربية والتعليم",
    "az": "MOE Paneli",
    "chinese": null,
    "eng": "MOE Dashboard",
    "hindi": null,
    "ja": "MOEダッシュボード",
    "jp": null,
    "ky": "MOE панели",
    "ru": "Панель управления MOE",
    "uz": "MOE boshqaruv paneli",
    "viet": "Bảng điều khiển MOE"
  },
  "search-district": {
    "arabic": "البحث عن المنطقة",
    "az": "Rayonu axtar",
    "chinese": null,
    "eng": "Search District",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "Издөө району",
    "ru": "Искать район",
    "uz": "Tumanni qidirish",
    "viet": null
  },
  "search-result-not-found": {
    "arabic": "لم يتم العثور على نتيجة البحث",
    "az": "Axtarış nəticəsi tapılmadı",
    "chinese": null,
    "eng": "Search result not found",
    "hindi": null,
    "ja": null,
    "jp": null,
    "ky": "Издөө натыйжасы табылган жок",
    "ru": "Результаты поиска не найдены",
    "uz": "Qidiruv natijalari topilmadi",
    "viet": null
  },
  "question": {
    "arabic": "سؤال",
    "az": "Sual",
    "chinese": "問題",
    "eng": "Question",
    "hindi": "प्रशन",
    "ja": "問題",
    "jp": null,
    "ky": "Суроо",
    "ru": "Вопрос",
    "uz": "Savol",
    "viet": "Câu hỏi"
  },
  "last-updated-at:": {
    "arabic": "آخر تحديث في:",
    "az": "Son yeniləmə:",
    "chinese": "最後更新:",
    "eng": "Last updated at:",
    "hindi": "अंतिम अद्यतन:",
    "ja": "最終更新:",
    "jp": "最終更新:",
    "ky": "Акыркы жаңыртылган убакыт:",
    "ru": "Последнее обновление в:",
    "uz": "So'nggi yangilangan vaqt:",
    "viet": "Cuối cùng được cập nhật tại:"
  },
}